import type { ActionIcon } from "@afar-research/agent-content/actions";
import {
  FileTextIcon,
  FlaskConicalIcon,
  HammerIcon,
  ImageIcon,
  LibraryBigIcon,
  PaletteIcon,
  PencilIcon,
  SparklesIcon,
  Trash2Icon,
  UsersIcon,
  WandSparklesIcon,
  type LucideIcon,
} from "lucide-react";

const ACTION_ICONS: Readonly<Record<ActionIcon, LucideIcon>> = {
  books: LibraryBigIcon,
  hammer: HammerIcon,
  flask: FlaskConicalIcon,
  palette: PaletteIcon,
  "file-text": FileTextIcon,
  users: UsersIcon,
  photo: ImageIcon,
  sparkles: SparklesIcon,
  trash: Trash2Icon,
  pencil: PencilIcon,
};

/** The icon an Action wears; a custom Action a skill declared wears the generic one. */
export function actionIconComponent(icon: ActionIcon | null): LucideIcon {
  return icon === null ? WandSparklesIcon : ACTION_ICONS[icon];
}
